import { get, post } from '@/utils/request'

/**
 * 用户注册信息接口定义
 */
export interface RegisterData {
  registerStep?: number
  childrenInfo?: {
    sex?: number
    birthYear?: number
    birthMonth?: number
    height?: number
    education?: number
    annualIncome?: number
    marriage?: number
    residenceProvince?: string
    residenceCity?: string
    residenceProvinceCode?: string
    residenceCityCode?: string
    hometownProvince?: string
    hometownCity?: string
    hometownProvinceCode?: string
    hometownCityCode?: string
    introduction?: string
    school?: string
    buyHouseInfo?: number
    buyCarInfo?: number
    jobInfo?: string
    /** 择偶条件-年龄最小值(-1不限) */
    criAgeMin?: number
    /** 择偶条件-年龄最大值(-1不限) */
    criAgeMax?: number
    /** 择偶条件-身高最小值(-1不限) */
    criHeightMin?: number
    /** 择偶条件-身高最大值(-1不限) */
    criHeightMax?: number
    /** 择偶条件-年收入最小值，5(5千以下),10(5千-8千),20(8千-1.2万), 30(1.2万-2万),60(2万-3万),100(3万-5万),101(5万以上)-1不限 */
    criAnnualIncome?: string
    /** 择偶条件-学历最小值，1-初中及以下，2-高中，3-大专，4-本科，5-硕士，6-博士-1不限 */
    criEducation?: string
    /** 择偶条件-购车1:已买车,2未买车,-1不限 */
    criBuyCarInfo?: number
    /** 择偶条件-购房情况1:现居地有房,2家乡地有房,3有购房计划,4打算婚后购房-1不限 */
    criBuyHouseInfo?: number
    /** 择偶条件-何时结婚:1:半年内结婚,2:一年内结婚,3:两年内结婚,4:时机成熟就结婚-1不限 */
    criMarriedInfo?: number
    /** 择偶条件-籍贯-省 */
    criHometownProvince?: string
    /** 择偶条件-籍贯-省编码 */
    criHometownProvinceCode?: string
    /** 择偶条件-籍贯-市 */
    criHometownCity?: string
    /** 择偶条件-籍贯-市编码 */
    criHometownCityCode?: string
    /** 择偶条件-居住-省 */
    criResidenceProvince?: string
    /** 择偶条件-居住-省编码 */
    criResidenceProvinceCode?: string
    /** 择偶条件-居住-市 */
    criResidenceCity?: string
    /** 择偶条件-居住-市编码 */
    criResidenceCityCode?: string
    /** 择偶条件-婚姻状况 */
    criMarriage?: string
  }
  parentInfo?: {
    sex?: number
    residenceProvince?: string
    residenceCity?: string
    residenceProvinceCode?: string
    residenceCityCode?: string
  }
}
// 收藏/取消收藏数据接口定义
export interface CollectOrCancelData {
  userId: number | string
  targetUserId: number | string
  source: number // 1-线下门店,2-小程序 3-APP
  status: number // 1-收藏,2-取消收藏
}
// 编辑用户资料参数类型定义
interface EditUserProfileParams {
  loginSource?: number
  children?: {
    birthYear?: number // 出生年份
    birthMonth?: number // 出生月份
    residenceProvinceCode?: string // 居住地省份编码
    residenceCityCode?: string // 居住地城市编码
    height?: number // 身高
    education?: number // 学历
    marriage?: number // 婚况
    annualIncome?: number // 月收入
    hometownProvinceCode?: string // 家乡省份编码
    hometownCityCode?: string // 家乡城市编码
    introduction?: string // 相亲说明
    buyCarInfo?: number // 购车情况
    buyHouseInfo?: number // 购房情况
    getMarriedInfo?: number // 何时结婚
    jobInfo?: string // 职业信息
    residenceProvince?: string // 居住地省份
    residenceCity?: string // 居住地城市
    hometownProvince?: string // 家乡省份
    hometownCity?: string // 家乡城市
    sex?: number // 性别
    school?: string // 毕业院校
  }
  parent?: {
    name?: string // 称呼
    education?: number // 学历
    annualIncome?: number // 月收入
    residenceProvinceCode?: string // 居住地省份编码
    residenceCityCode?: string // 居住地城市编码
    residenceProvince?: string // 居住地省份
    residenceCity?: string // 居住地城市
    sex?: number // 性别
  }
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  return get<Myself>('/app/user/myself')
}

// 查看用户详情
export function getUserDetail(data: any) {
  return get<Myself>('/app/user/userinfo', data)
}

/**
 * 用户登录
 * @param data 登录数据
 * @returns Promise<any> 注册结果
 */
export function userLogin(data: any) {
  return post<WxLoginInfo_User>('/parmatch/login/webLogin', data)
}

/**
 * 修改用户信息
 * @param data 用户信息
 */
export function updateUserInfo(data: Partial<Myself>) {
  return post<Myself>('/user/update', data)
}

/**
 * 用户注册
 * @param data 注册数据
 * @returns Promise<any> 注册结果
 */
export function register(data: RegisterData) {
  return post<any>('/app/user/register', data)
}

/**
 * 收藏/取消收藏
 * @param data 收藏/取消收藏数据
 * @returns Promise<any> 收藏/取消收藏结果
 */
export function collectOrCancel(data: CollectOrCancelData) {
  return post<any>('/parmatch/user-favorite/create', data)
}

// 修改孩子信息
export function updateChildrenInfo(data: EditUserProfileParams) {
  return post<any>('/app/user/edit', data)
}
// 我的收藏 分页查询
export function getMyCollect(data: any) {
  return get<any>('/parmatch/user-favorite/page', data)
}

// 发送验证码
export function sendVerificationCode(data: any) {
  return post<any>('/parmatch/login/send-sms-code', data)
}

// 校验验证码
export function checkVerificationCode(data: any) {
  return post<any>('/parmatch/login/validate-sms-code', data)
}
